<!--Title-->
<div>
	<label>Group:</label>
	<label>{{ GroupName }}</label>
</div>

<!--Main Grid-->
<div class="MainMenu">
	<label style="margin-top: 10px">Select Group Action Type:</label>

	<!--Radio Group-->
	<div class="MainGrid2Col CenterWidth">
		<input id="Incident" value="Incident" name="RadioOption" [(ngModel)]="RadioOption" type="radio" />
		<label for="Incident">Incident</label>

		<input id="Release" value="Release" name="RadioOption" [(ngModel)]="RadioOption" type="radio" />
		<label for="Release">Release</label>

		<input id="Fine" value="Fine" name="RadioOption" [(ngModel)]="RadioOption" type="radio" />
		<label for="Fine">Fine</label>

		<input id="PBIS" value="PBIS" name="RadioOption" [(ngModel)]="RadioOption" type="radio" />
		<label for="PBIS">PBIS</label>

		<input id="Reminder" value="Reminder" name="RadioOption" [(ngModel)]="RadioOption" type="radio" />
		<label for="Reminder">ScanStation Reminder</label>

		<input id="PortalNotification" value="PortalNotification" name="RadioOption" [(ngModel)]="RadioOption" type="radio" />
		<label for="PortalNotification">Portal App Notification</label>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onOk()">Ok</button>
	<button class="btn btn-warning" (click)="onClose()">Close</button>
</div>
